import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, OnDestroy, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ISiteInfoResponse } from '../interfaces/common';
import { IGetWorkLocationDetailsResponse } from '../interfaces/common';
import { IUserContact } from '../interfaces/common';

@Injectable({
  providedIn: 'root',
})
export class SharedServices implements OnDestroy {
  private dataSignal = signal<boolean>(false);
  private cwsId: string = '';

  private cwsIdSubject = new BehaviorSubject<string | null>(
    localStorage.getItem('cwsId'),
  );
  cwsId$ = this.cwsIdSubject.asObservable();
  apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  setCwsId(id: string | null | undefined): void {
    if (id) {
      localStorage.setItem('cwsId', id);
      this.cwsIdSubject.next(id);
    }
  }

  getCwsId(): string | null {
    return this.cwsIdSubject.value;
  }

  setData(data: any) {
    this.dataSignal.set(data);
  }

  getData() {
    return this.dataSignal.asReadonly();
  }

  getSiteCodeList(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/SiteCode`);
  }

  getSiteInfo(siteId: string): Observable<ISiteInfoResponse> {
    const params = new HttpParams().set('SiteId', siteId.toString());
    return this.http.get<ISiteInfoResponse>(`${this.apiUrl}/GetSiteInfo`, {
      params,
    });
  }

  getWorkLocationDetails(): Observable<IGetWorkLocationDetailsResponse> {
    return this.http.get<IGetWorkLocationDetailsResponse>(
      `${this.apiUrl}/GetWorkLocationDetails`,
    );
  }

  getContacts(searchText: string): Observable<IUserContact[]> {
    return this.http.get<IUserContact[]>(
      `${this.apiUrl}/api/MyProfile/FilterIAMServiceBySearchCriteria/displayname/sw/${searchText}`,
    );
  }
  getSegmentDivisionManagers(
    segment?: string | null,
    division?: string | null,
  ): Observable<IUserContact[]> {
    let params = new HttpParams();
    if (segment) {
      params = params.set('segment', segment);
    }
    if (division) {
      params = params.set('division', division);
    }
    return this.http.post<IUserContact[]>(
      `${this.apiUrl}/api/MyProfile/GetSegmentDivisionManagers`,
      null,
      { params },
    );
  }

  ngOnDestroy(): void {
    this.cwsIdSubject.complete();
  }
}
